export const API_URL = "https://core.pluritongues.com";
console.log(API_URL);
